export default "/react/logoAnanasClick-6a049727.png";